import type {
  DocumentCreateRequest,
  DocumentResponse,
  DocumentUpdateRequest,
} from 'src/api/ProactApiClient';
import type {IFormFieldV2} from 'src/types/FormV2';

export const pageTitleDict: {[key: string]: {[key: string]: string}} = {
  toolboxtalk: {singular: 'Toolbox Talk', plural: 'Toolbox Talks'},
  actions: {singular: 'Action', plural: 'Actions'},
  training: {singular: 'Training', plural: 'Training'},
  assignedforms: {singular: 'Form', plural: 'Assigned Forms'},
};

export const DocumentListMeta = {
  label: 'name',
};

export const FolderMeta: IFormFieldV2[] = [
  {
    name: 'name',
    label: 'Folder Name',
    type: 'text',
    required: true,
  },
];

export const FileMeta: IFormFieldV2[] = [
  {
    name: 'name',
    label: 'File Name',
    type: 'text',
    required: true,
  },
  {
    name: 'summaryDescription',
    label: 'Summary',
    type: 'text',
    validation: {
      maxLength: 1000,
    },
    required: true,
  },
  {
    name: 'attachmentURL',
    label: 'File',
    type: 'file',
    required: true,
    description:
      "To update the attachment, delete the old attachment and upload the new attachment. Older versions will be saved in the document's history.",
    validation: {
      maxLength: 10000,
    },
    fileUploadOptions: {
      allowMultiple: false,
      isHideUploadSuccessEnabled: true,
    },
  },
];

export const MapDocumentResponseToDocumentCreateRequest = (
  data: DocumentResponse
): DocumentCreateRequest => {
  return {
    parentId: data.parentId,
    name: data.name,
    summaryDescription: data.summaryDescription ?? '',
    attachmentURL: data.attachmentURL ?? '',
    isFolder: data.isFolder ?? false,
  };
};

export const MapDocumentResponseToDocumentUpdateRequest = (
  data: DocumentResponse
): DocumentUpdateRequest => {
  return {
    id: data.id,
    name: data.name,
    summaryDescription: data.summaryDescription ?? '',
    attachmentURL: data.attachmentURL ?? '',
    version: data.version,
  };
};

export const documentTitle = 'Document Management';
